export class Language{
    uid: string;
    name: string;
}
